import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// Función para obtener cookies
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    try {
      // Obtener el token JWT de las cookies
      const jwtToken = getCookie('jwt');

      // Establecer los encabezados de Axios para CSRF y JWT
      axios.defaults.headers.common['X-XSRF-TOKEN'] = getCookie('XSRF-TOKEN'); // CSRF token
      axios.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`; // JWT token

      const response = await axios.get('/user', {
        withCredentials: true,  // Para asegurar que se envíen las cookies
        headers: {
          'Accept': 'application/json', // Asegúrate de incluir este header
        },
      });

      setUser(response.data);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setUser(null); // Si no es autorizado, limpiamos el estado del usuario
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, loading, fetchUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};
